import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DataService} from "../../../services/data.service";


@Component({
   selector: 'app-top-control',
   templateUrl: './top-control.component.html',
   styleUrls: ['./top-control.component.scss']
})
export class TopControlComponent implements OnInit {

   @Input("isNew") isNew = false;
   @Input("showAdd") showAdd = false;
   @Input("showSave") showSave = true;
   @Input("disabled") disabled = true;

   @Output("onEdit") onEdit = new EventEmitter<boolean>()
   @Output("onDelete") onDelete = new EventEmitter<any>()
   @Output("onSave") onSave = new EventEmitter<any>()
   @Output("onAdd") onAdd = new EventEmitter<any>()

   public inEdit: boolean = false;
   is_disabled:boolean = true


   constructor(
      public dataSrv: DataService) { }

   ngOnInit(): void {

   }

   clickEliminaItem() {
      this.onDelete.emit()
   }

   clickEditItem(value) {
      this.inEdit=value;
      this.onEdit.emit(value)
   }

   clickAddItem() {
      this.onAdd.emit()
   }

   clickSave() {
      this.onEdit.emit()
   }
}
